module.exports = "/call-frontend/img/icon_star_active.fd490aad.svg";